import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/ui/page-header";
import { ensureElementVisible } from "@/lib/route-guards";

// Sufiks `_` wypina trase z zagniezdzenia w `/rda/lista-ofert-fm1` (ta nie ma
// <Outlet/>), zachowujac URL /rda/lista-ofert-fm1/{id}.
function OfertaFm1DetailPlaceholder() {
	const { offerId } = useParams({ from: "/_auth/rda/lista-ofert-fm1_/$offerId" });

	return (
		<div className="flex flex-col gap-4 p-6 max-md:gap-3 max-md:p-3">
			<PageHeader
				title={`Oferta FM1 #${offerId}`}
				description="Strona w budowie. Docelowo pokaże pozycje oferty (BLOZ, ceny, rabaty per hurtownia) z oferty_dla_aptek_item."
			/>
			<div>
				<Button variant="outline" size="sm" className="h-8 max-md:h-9" asChild>
					<Link to="/rda/lista-ofert-fm1">
						<ArrowLeft className="size-3.5" />
						Wróć do listy ofert
					</Link>
				</Button>
			</div>
		</div>
	);
}

export const Route = createFileRoute("/_auth/rda/lista-ofert-fm1_/$offerId")({
	// Ten sam element co lista — szczegol oferty nie jest osobnym uprawnieniem.
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.rda.lista-ofert-fm1",
			location.pathname,
		);
	},
	component: OfertaFm1DetailPlaceholder,
});
